export default __webpack_public_path__ + "static/media/GalanoGrotesque-ExtraBold.69fd838a.ttf";